/**
 * Logger utility — replaces raw console calls with build-time-aware logging.
 * In production, console.debug is stripped entirely and console.warn/error
 * are no-ops (Sentry captures real errors). In dev, everything passes through.
 */

const IS_DEV = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => {
    if (IS_DEV) console.debug(...args);
  },
  warn: (...args: unknown[]) => {
    if (IS_DEV) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Always log errors — but in production we could also send to Sentry
    console.error(...args);
  },
};
